window.loginUser = function(){
    let formValues = $('#login_form').serialize();
    $('#login_form .error-text').removeClass('d-block');
    $('#login_form .error-text').addClass('d-none');
    $('#login_loading_spinner').show();
    $('.submit_form').hide();
    $('#login_success').html('').hide();

    setTimeout(function() {
        axios.post(routes.ClientAdminAuthenticate, formValues)
        .then(function(response){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'log_in',
                'user_id': response.data.user_id,
                'user_email': response.data.user_email,
            });

            window.location.href = response.data.route;          
        }).catch(function(errors){             
            if(errors.response.status == 401){     
                $('#login_loading_spinner').hide();              
                $('#login_success').html(errors.response.data.message).show();                
                $('.submit_form').show();               

            }else if(errors.response.status == 422){
                $('#login_loading_spinner').hide();
                $('.submit_form').show();               
                $.each(errors.response.data.errors, function (className, error) { 
                     $(`#login_form .${className}`).text(error).addClass('d-block');
                });
             
            }else{
                $('#login_loading_spinner').hide();
                $('#login_success').html(translations.Error).show();                                 
                $('.submit_form').show();               
            }           
        }); 
    }, 1000);    
}